import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { PaymentAllocation } from 'src/features/paymentAllocations/utils/types';

const RESOURCE = '/payments/payment-allocation/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    payment?: string;
    financial_document?: string;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<PaymentAllocation>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_PAYMENT_ALLOCATIONS_RESOURCE, useQueryHook as useListPaymentAllocations };
